/* eslint no-underscore-dangle: ["error", { "allow": ["_id", "_created", "_items"] }] */
import PropTypes from 'prop-types';

import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';

import actions from '../../state/actions';
import SelectLocations from '../../components/SelectLocations';
import WorkorderFormCard from './WorkorderFormCard';
import sortUtils from '../../utils/sort';
import Screen from '../../components/Screen';
import { HistoryType } from '../../types/router';
import { localize } from '../../i18n';

import './WorkorderEdit.css';

const mapWorkorder = function mapWorkorder(props) {
  if (props.workorder) {
    return {
      form: {
        type: props.workorder.type,
        locations: props.workorder.locations,
        priority: props.workorder.priority,
        body: props.workorder.body,
        assigned: props.workorder.assigned,
        status: props.workorder.status,
        due_date: props.workorder.due_date,
        summary: props.workorder.summary || null,
        description: props.workorder.description || null,
      },
      formSubmittable: false,
      departmentFilter: 'all',
    };
  }
  return {};
};

class WorkorderEdit extends Component {
  constructor(props) {
    super(props);
    this.didProcessRequest = false;
    this.workorderLoaded = false;
    this.state = {
      workorderForm: {},
      updating: false,
      showSection: null,
      addedComments: [],
      selectedLocations: [],
    };
  }

  componentWillMount() {
    this.loadData(this.props);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.actionType === 'API_UPDATED') {
      this.goToView('details');
    }
    if (nextProps.actionType === 'API_UPDATE_FAILED') {
      this.setState({
        updating: false,
      });
    }
    this.loadData(nextProps);
  }

  loadData(props) {
    if (this.didProcessRequest === false) {
      this.didProcessRequest = true;
      this.props.processRequest(props.workorderId);
    }
    if (this.workorderLoaded === false && props.workorder) {
      this.workorderLoaded = true;
      this.setState({
        workorderForm: mapWorkorder(props),
      });
    }
    if (props.workorder && props.locationsLoaded) {
      const selectedLocations = props.workorder.locations;
      this.setState({
        selectedLocations,
      });
    }
  }

  goToView(view) {
    this.goLocation(`/access/workorders/${this.props.workorderId}/${view}`);
  }

  goLocation(path) {
    const { history } = this.props;

    history.push(path);
  }

  toggleSection(showSection, workorderForm) {
    const newState = {
      showSection,
    };
    if (workorderForm) {
      newState.workorderForm = workorderForm;
    }
    this.setState(newState);
  }

  handleSelectLocations(changedLocations) {
    this.setState(Object.assign({}, this.state, {
      selectedLocations: changedLocations,
    }), () => {
      this.toggleSection(null);
    });
  }

  handleNewComments(newComments) {
    this.setState(Object.assign({}, this.state, {
      addedComments: newComments,
    }), () => {
      this.toggleSection(null);
    });
  }

  handleOnSubmit(form) {
    const updateForm = Object.assign({}, form);
    delete updateForm.type;

    if (this.props.workorder.due_date === form.due_date) {
      delete updateForm.due_date;
    }

    if (this.props.workorder.status === form.status) {
      delete updateForm.status;
    }

    if (updateForm.assigned === '') {
      updateForm.assigned = null;
    }

    this.setState({
      updating: true,
    }, () => {
      this.props.updateWorkorder(this.props.workorderId, updateForm);
    });
  }

  render() {
    const {
      workorderForm,
      updating,
      showSection,
      selectedLocations,
      addedComments,
    } = this.state;
    const {
      workorder,
      actionType,
      locationsLoaded,
      channels,
      locations,
      locationTypes,
      workorderConfigs,
      selectedAffiliateInfo,
      staffList,
    } = this.props;

    let workorderUpdateDisplay = null;
    if (workorder) {
      if (showSection === 'locations') {
        workorderUpdateDisplay = (
          <SelectLocations
            locations={locations}
            locationTypes={locationTypes}
            selectedLocations={selectedLocations}
            onSelectLocations={changeLocations => this.handleSelectLocations(changeLocations)}
          />
        );
      } else {
        workorderUpdateDisplay = (
          <WorkorderFormCard
            edit
            validStatusTransitions={workorder.valid_status_transitions || []}
            staffList={staffList}
            workorderNumber={workorder.number}
            actionType={actionType}
            workorderForm={workorderForm}
            locationsLoaded={locationsLoaded}
            channels={channels}
            locations={locations}
            workorderConfigs={workorderConfigs}
            onCancel={() => this.goToView('details')}
            selectedAffiliateInfo={selectedAffiliateInfo}
            selectedLocations={selectedLocations}
            addedComments={addedComments}
            toggleSection={(section, changeWorkorderForm) => this.toggleSection(section, changeWorkorderForm)}
            submittingForm={updating}
            onSubmit={form => this.handleOnSubmit(form)}
          />
        );
      }
    } else {
      workorderUpdateDisplay = (
        <div className="md-card">
          <div className="md-card-content" />
        </div>
      );
    }

    return (
      <Screen title={this.props.t('Work Orders')} helpUrl="#wo">
        <div className="WorkorderEdit">
          <div className="uk-grid uk-flex-center">
            <div className="uk-width-small-4-5 uk-width-mobile-1-1">
              {workorderUpdateDisplay}
            </div>
          </div>
        </div>
      </Screen>
    );
  }
}

WorkorderEdit.propTypes = {
  // eslint-disable-next-line
  actionType: PropTypes.string,
  workorderId: PropTypes.string,
  workorder: PropTypes.shape({
    _id: PropTypes.string,
    status: PropTypes.string,
    due_date: PropTypes.string,
    channel: PropTypes.string,
    type: PropTypes.string,
    severity: PropTypes.string,
    label: PropTypes.string,
    room: PropTypes.string,
    epochs: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.number,
    })),
    body: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    _created: PropTypes.string,
    assigned: PropTypes.objectOf(PropTypes.any),
    user_comment: PropTypes.string,
  }),
  history: HistoryType,
  locationsLoaded: PropTypes.bool,
  locations: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    location_type: PropTypes.string,
    location_name: PropTypes.string,
    location_sort: PropTypes.number,
  })),
  locationTypes: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    type: PropTypes.string,
    attributes: PropTypes.objectOf(PropTypes.any),
  })),
  channels: PropTypes.arrayOf(PropTypes.object),
  workorderConfigs: PropTypes.arrayOf(PropTypes.object),
  staffList: PropTypes.arrayOf(PropTypes.object),
  selectedAffiliateInfo: PropTypes.shape({
    attributes: PropTypes.objectOf(PropTypes.any),
    id: PropTypes.string,
    type: PropTypes.string,
  }),
  processRequest: PropTypes.func,
  updateWorkorder: PropTypes.func,
  t: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => {
  let workorder;
  let locations = [];
  let locationTypes = [];
  let workorderConfigs = [];
  const actionType = state.action.type;
  let locationsLoaded = false;

  const {
    match: {
      params: {
        workorderId,
      },
    },
  } = ownProps;

  const {
    session: {
      channels,
      affiliate: selectedAffiliateInfo,
    },
    affiliates: {
      staffList,
    },
  } = state;

  if (state.ticket.work_order) {
    workorder = _.find(state.ticket.work_order._items, { _id: workorderId });
  }

  if (state.ticket.work_order_config) {
    workorderConfigs = _.sortBy(_.filter(state.ticket.work_order_config._items, w => w.display), ['work_order_label']);
  }
  if (state.api.location_type) {
    locationTypes = state.api.location_type.data;
  }
  if (locationTypes && state.api.GemsRooms) {
    locations = _.sortBy(_.map(state.api.GemsRooms.data, loc => ({
      id: loc.id,
      location_type: loc.attributes.location_type.kind,
      location_name: loc.attributes.name.toString(),
      location_sort: sortUtils.getStringSortValue(loc.attributes.name),
    })), ['location_sort']);
  }
  if (state.loading.api.locations) {
    locationsLoaded = state.loading.api.locations;
  }

  return {
    workorderId,
    workorder,
    locationsLoaded,
    actionType,
    locations,
    locationTypes,
    channels,
    workorderConfigs,
    selectedAffiliateInfo,
    staffList,
  };
};

const mapDispatchToProps = dispatch => ({
  processRequest(workorderId) {
    dispatch(actions.retrieveWorkorderConfigs());
    const loadAll = true;
    dispatch(actions.retrieveLocations(loadAll));
    dispatch(actions.retrieveLocationTypes());
    dispatch(actions.retrieveStaffList());
    dispatch(actions.retrieveWorkorderById(workorderId));
    dispatch(actions.retrieveWorkorderComments(workorderId));
  },
  updateWorkorder(workorderId, payload) {
    dispatch(actions.updateWorkorder(workorderId, payload));
  },
});

export default localize(connect(mapStateToProps, mapDispatchToProps)(WorkorderEdit));



// WEBPACK FOOTER //
// ./src/views/workorders/WorkorderEdit.js